// 一键找人
export default [
  {
    path: '/track/addressbook',
    name: 'PageTrackAddressbook',
    component: () =>
      import(
        /* webpackChunkName: "track" */ '../pages/track/PageTrackAddressbook'
      ),
    meta: {
      modular: 113,
      title: '一键找人',
      info: '一键找人——首页'
    }
  },
  {
    path: '/track/record',
    name: 'PageTrackRecord',
    component: () =>
      import(/* webpackChunkName: "track" */ '../pages/track/PageTrackRecord'),
    meta: {
      modular: 113,
      title: '详情',
      info: '一键找人——个人轨迹详情'
    }
  }
]
